"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueStatusesAPI = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssueStatusesAPI = exports.IssueStatusesAPI = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: () => api.getAll("active-statuses"),
    set: newActiveStatuses => api.set("active-statuses", newActiveStatuses)
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.INVALIDATE_ALL_QUERIES
});
//# sourceMappingURL=IssueStatusesAPI.js.map